import React, { useEffect, useState, useRef } from 'react';
// @ts-ignore
import { Input, MultipleInput } from '@jd/jmtd';
import '../../../../../yx.css';
import '../../../../../yx-pro.css';
import '../../../../../yx-extra.css';

function AnalysisTable(props: any) {
  const { onChange, onChangeSearch } = props;
  const _onChange = useRef(onChange);
  const [tabsIdx, setTabsIdx] = useState(0);
  const [searchValue, setSearchValue] = useState({ tags: [], input: '' });
  const isChange = useRef(false);
  /**
   * 修改Tab选择
   * @param {number} idx
   */
  const modifyTabChoose = (idx: number) => {
    isChange.current = true;
    setTabsIdx(idx);
  };

  const placeholderMap = {
    '0': '最多可输入20个SKU，以","分隔',
    '1': '最多可输入20个关键词，以","分隔',
    '2': '最多可输入20个店铺ID，以","分隔'
  };
  /**
   * 监听指标变化
   */
  useEffect(() => {
    if (!_onChange.current || !isChange.current) return;
    _onChange.current({
      tabsIdx: tabsIdx
    });
    setSearchValue({
      tags: [],
      input: ''
    });
  }, [tabsIdx]);


  const handleSearchValue = (tag: any, idx:number) => {
    const p: any = {
    };
    if (idx === 0) {
      p['sku_id'] = searchValue?.tags ?? [];
    } else if (idx === 1) {
      p['keyword'] = searchValue?.tags ?? [];
    } else if (idx === 2) {
      p['shop'] = searchValue?.tags ?? [];
    }
    onChangeSearch({
      ...p
    });
  };

  return (
    <div className='analysis-tab-panel'>
      {/* 分析tab标签 */}
      <ul className='analysis-tab-list'>
        {['商品分析', '关键词分析', '店铺分析'].map((item, idx) => {
          return (
            <li
              className={`analysis-tab-list-item ${idx === tabsIdx ? 'analysis-tab-list-item-active' : ''}`}
              key={idx}
              onClick={() => modifyTabChoose(idx)}
            >
              {item}
            </li>
          );
        })}
      </ul>
      {tabsIdx === 0 && <Input placeholder='最多可输入20个SKU，以","分隔' showSearch render={MultipleInput} value={searchValue} onChange={setSearchValue}
                               onSearch={(val:any)=>{handleSearchValue(val, 0)}} showLength maxLength={20} />}
      {tabsIdx === 1 && <Input placeholder='最多可输入20个关键词，以","分隔' showSearch render={MultipleInput} value={searchValue} onChange={setSearchValue}
                               onSearch={(val:any)=>{handleSearchValue(val, 1)}} showLength maxLength={20} />}
      {tabsIdx === 2 && <Input placeholder='最多可输入20个店铺ID，以","分隔' showSearch render={MultipleInput} value={searchValue} onChange={setSearchValue}
                               onSearch={(val:any)=>{handleSearchValue(val, 2)}} showLength maxLength={20} />}
    </div>
  );
}

export default AnalysisTable;
